import {
  DistributionCenterAction,
  DistributionCenterState,
} from 'store/data/distributionCenter';
import { domainUtility } from 'utility';

const initialState: DistributionCenterState = { allIds: [], byId: {} };

const distributionCenterReducer = (
  state: DistributionCenterState = initialState,
  action: DistributionCenterAction,
): DistributionCenterState => {
  switch (action.type) {
    case 'data/distributionCenter/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/distributionCenter/SET':
      return domainUtility.set(state, action.payload);
    case 'data/distributionCenter/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/distributionCenter/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/distributionCenter/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default distributionCenterReducer;
